// Raised when a 2xx upload response resolves with a non-object body —
// axios yields "" for an empty body, so downstream code that expects an
// artwork object would fail. Classified as transient (see
// isTransientServerError) so the upload retry loop re-attempts the request.
export class EmptyResponseBodyError extends Error {
  constructor(bodyType: string) {
    super(`Artwork upload resolved with ${bodyType} body instead of an artwork object`);
    this.name = "EmptyResponseBodyError";
  }
}
